import { css } from '@emotion/css';
import cls from 'classnames';
import { FC, ReactNode } from 'react';
import theme from 'tailwind/theme';

import useLockBodyScroll from '@/lib/hooks/use-lock-body-scroll';

// TODO: remove one of icon-cross, cross-icon
import CrossIcon from '../icons/icon-cross';
import Portal from '../portal';

interface ModalProps {
  className?: string;
  contentClassName?: string;
  headerActions?: ReactNode;
  onClose?: () => void;
  showCloseIcon?: boolean;
}

const modalOverlay = css`
  background-color: rgba(0, 0, 0, 0.5);
`;

const modalContentWrapper = css`
  @media (min-width: ${theme.screens.md}) {
    height: auto;
    max-height: 85vh;
  }
`;

const Modal: FC<ModalProps> = ({
  className = '',
  contentClassName = '',
  children,
  headerActions,
  onClose,
  showCloseIcon = true,
}) => {
  useLockBodyScroll();

  const renderHeaderActions = () => (
    <div
      className={cls(
        'fixed flex items-center gap-6 md:gap-4 right-6 top-20',
        'md:absolute md:top-4 md:right-4 md:z-10',
        'lg:right-6',
      )}
    >
      {headerActions}
      <div
        className="w-8 h-8 bg-white flex justify-center items-center rounded-16 cursor-pointer"
        onClick={onClose}
      >
        <CrossIcon />
      </div>
    </div>
  );

  return (
    <Portal>
      <div
        className={cls(
          'fixed inset-x-0 bottom-0 top-16 z-60 flex justify-center items-center h-auto',
          modalOverlay,
          className,
        )}
      >
        <div className="md:content-box-centered h-full md:h-auto">
          <div className="relative w-screen md:w-2/3 mx-auto h-full md:h-auto">
            {showCloseIcon && (
              <div className="hidden md:block">{renderHeaderActions()}</div>
            )}

            <div
              className={cls(
                'relative overflow-y-auto overflow-x-hidden md:rounded-4 bg-black-light h-full md:h-auto tesn:bg-esn-secondary teair:bg-air-lightBlue teair:text-air-mediumBlue',
                modalContentWrapper,
                contentClassName,
              )}
            >
              {showCloseIcon && (
                <div className="block md:hidden">{renderHeaderActions()}</div>
              )}

              {children}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default Modal;
